export const CompanyPermission = {
  CREATE: 1,
  EDIT: 2,
  DELETE: 4,
  REVIVAL: 8,
  DELETE_PERMANET: 16,
  SEARCH: 32,
  GET: 64
};

// ----------------------------------------------------------------------------------
// ポータル
// ----------------------------------------------------------------------------------

export const PortalPermission = {
  MANAGER_SETTING: 1,
  SYSTEM_DOWNLOAD: 2,
  SUPPORT: 4,
  CONTRACT: 8
};

export const BulletinBoardPermission = {
  CREATE: 1, // 作成権限
  EDIT: 2, // 編集権限(他者の物)
  DELETE: 4, // 削除権限(他者の物)
  CATEGORY_CREATE: 8, // カテゴリ追加権限
  COMPANY_SETTING: 16 // 会社設定権限
};

export const DocumentRepoPermission = {
  CREATE: 1, // 作成権限
  EDIT: 2, // 編集権限(他者の物)
  DELETE: 4, // 削除権限(他者の物)
  CATEGORY_CREATE: 8 // カテゴリ追加権限
};

// ----------------------------------------------------------------------------------
// 物件管理
// ----------------------------------------------------------------------------------

export const BukkenPermission = {
  // CREATE: 1,
  // DELETE: 2
  CREATE: 2,
  DELETE: 8,
  RECOVER: 16,          // 復元
  DELETE_PERMANENT: 32  // 完全削除
};

/** 物件個別の権限ビットフラグ（APIレスポンスの bukken_authority 用） */
export const BukkenAuthorityBit = {
  VIEW: 1,              // 閲覧
  CREATE: 2,            // 登録
  EDIT: 4,              // 編集
  DELETE: 8,            // 削除
  RECOVER: 16,          // 復元
  DELETE_PERMANENT: 32, // 完全削除
};

/** 物件個別の権限2ビットフラグ（APIレスポンスの bukken_authority2 用） */
export const BukkenAuthority2Bit = {
  PARTICIPANT_EDIT: 1,  // 参加者権限編集
};

/** ファイルタブ権限ビット（参加者権限設定画面用 — file_authority） */
export const FileTabAuthorityBit = {
  VIEW: 1,
  CREATE: 2,
  EDIT: 4,
  DELETE: 8,
  DOWNLOAD: 64,
};

/** ファイルタブ権限2ビット（参加者権限設定画面用 — file_authority2） */
export const FileTabAuthority2Bit = {
  SELF_EDIT: 1,
  SELF_DELETE: 2,
  ACCESS: 4,
};

/** フォルダアイテム権限ビット（ファイル/フォルダ取得APIレスポンスの folder.authority.authority 用） */
export const FolderItemAuthorityBit = {
  VIEW: 1,
  CREATE: 2,
  EDIT: 4,
  DELETE: 8,
  DOWNLOAD: 64,
};

/** フォルダアイテム権限2ビット（folder.authority.authority2 用） */
export const FolderItemAuthority2Bit = {
  SELF_EDIT: 1,
  SELF_DELETE: 2,
  ACCESS: 4,
};

/** ファイルアイテム権限ビット（ファイル/フォルダ取得APIレスポンスの file.authority.authority 用） */
export const FileItemAuthorityBit = {
  VIEW: 1,
  EDIT: 4,
  DELETE: 8,
  DOWNLOAD: 64,
};

/** ファイルアイテム権限2ビット（file.authority.authority2 用） */
export const FileItemAuthority2Bit = {
  SELF_EDIT: 1,
  SELF_DELETE: 2,
  ACCESS: 4,
};

export const BukkenRegisterdPermission = {
  STORAGE: 1,
  PHOTO_STORAGE: 2,
  DRAWING:4,
  INSPECTION:8
};

export const BukkenSettingPermission = {
  SETTING: 1
};

export const BukkenRecoverOrDeletePermission = {
  RECOVER: 1,
  DELETE_PERMANENT: 2
};

// ----------------------------------------------------------------------------------
// 書式ダウンロード
// ----------------------------------------------------------------------------------

export const LocalConfPermission = {
  DOWNLOAD: 1
};

// ----------------------------------------------------------------------------------
// 共有ストレージ
// ----------------------------------------------------------------------------------
export const ShareStoragePermission = {
  DISPLAY: 1,         // 表示
  FILE_OPERATION: 2,  // ファイル操作 
  TOOL_CONNECT: 4     // 同期ツール連携
};

// ----------------------------------------------------------------------------------
// ANDESバックアップ
// ----------------------------------------------------------------------------------

export const ANDESBackupPermission = {
  BACKUP: 1,
  RESTORE: 2,
  EDIT: 4,
  DELETE: 8
};


export const SettingPermission = {
  CAPACITY: 1,
  VERSION: 2,
  BACKUP: 4,
  GET: 8
};

export const UserPermission = {
  GET: 1
};

export const DairyReportPermission = {
  CREATE: 1,
  EDIT: 2,
  DELETE: 4,
  OTHER_USER_VIEW: 1,
  OTHER_USER_EDIT: 2,
  OTHER_USER_DELETE: 4,
  TEMPLATE_CREATE: 1,
  TEMPLATE_EDIT: 2,
  TEMPLATE_DELETE: 4,
};

export const QuotationPermission = {
  CREATE: 1, // 作成・編集権限
  DELETE: 2,  // 削除権限
}

export const QuotationTempTextPermission = {
  MESSAGE: 1, // メッセージ編集権限
  NOTE: 2,    // 備考編集権限
}

export const QuotationOthersPermission = {
  VIEW: 1,    // 他者の請求書の閲覧権限
  EDIT: 2,  // 他者の請求書の編集権限
  DELETE: 4, //  他者の請求書の削除権限
}

export const InvoicePermission = {
  CREATE: 1, // 作成・編集権限
  DELETE: 2,  // 削除権限
}

export const InvoiceOthersPermission = {
  VIEW: 1,    // 他者の請求書の閲覧権限
  EDIT: 2,  // 他者の請求書の編集権限
  DELETE: 4, //  他者の請求書の削除権限
}

export const InvoiceTempTextPermission = {
  MESSAGE: 1, // メッセージ編集権限
  NOTE: 2,    // 備考編集権限
}

export const AttendancePermission = {
  EDITALL: 1,   // 他者の編集可否
  EDITSELF: 2,  // 自身の勤怠編集可否
  VIEWALL: 4,   //  他者の勤怠閲覧権限
  ADMIN: 8,     //  日次勤怠表示権限
  SETTING: 16,  //  設定表示権限
}

export const WhiteBoardPermission = {
  EDIT: 4
}

export const AuthorityUUID = {
  // コメント：権限チェックの使用例
  /* ------------------------------------------------------------------ */
  // hasPermission(BukkenPermission.DELETE, AuthorityUUID.Bukken) 
  /* ------------------------------------------------------------------ */
  // "Bukken": "00000000-0000-0000-0000-000000000002",
  "BukkenRegisterd": "00000000-0000-0000-0000-000000000003",
  "BukkenSetting": "00000000-0000-0000-0000-000000000004",
  "BukkenRecoverOrDelete": "00000000-0000-0000-0000-000000000005",
  //
  "Bukken": "00000000-0000-0000-0000-000000000031",
  //
  "Portal": "00000000-0000-0000-0000-000000000006",
  "ShareStorage": "00000000-0000-0000-0000-000000000009",
  "LocalConf": "00000000-0000-0000-0000-000000000010",
  "ANDESBackup": "00000000-0000-0000-0000-000000000020",
  "DairyReport": "00000000-0000-0000-0000-100000000001",
  "DairyReportOthers":"00000000-0000-0000-0000-100000000002",
  "DairyReportTemplate":"00000000-0000-0000-0000-100000000003",
  "Quotation": "00000000-0000-0000-0000-100000000101",
  "QuotationOthers": "00000000-0000-0000-0000-100000000102",
  "Invoice": "00000000-0000-0000-0000-100000000201",
  "InvoiceOthers": "00000000-0000-0000-0000-100000000202",
  "AttendaceEdit"    : "00000000-0000-0000-0000-100000010001",
  "AttendaceDispEmployee"    : "00000000-0000-0000-0000-100000010002",
  "AttendaceAdmin"    : "00000000-0000-0000-0000-100000010003",
  "AttendaceSetting"    : "00000000-0000-0000-0000-100000010003",
  "BulletinBoard": "00000000-0000-0000-0000-000000000007",
  "DocumentRepo": "00000000-0000-0000-0000-000000000008",
  "Whiteboard": "00000000-0000-0000-0000-000000000011"
}

/**
 * 権限があるかチェックする
 * @param {*} permissionKey
 * @param {*} authorityUUID
 * @returns
 */
export const hasPermission = (permissionKey, authorityUUID) => {
  const authority = localStorage.getItem("authorities");
  if(!authority) {
    return true;
  }

  if(authority === "undefined") {
    return true;
  }

  const authMap = JSON.parse(authority);
  if(authorityUUID in authMap) {
    if((permissionKey & authMap[authorityUUID].value) === permissionKey) {
      return true;
    }
    return false;
  }

  // マスタに権限がない場合(=SNCの不手際等でマスタ登録ができていない場合)
  return true;
};

/**
 * authority2に権限があるかチェックする
 * @param {*} permissionKey
 * @param {*} authorityUUID
 * @returns
 */
export const hasPermission2 = (permissionKey, authorityUUID) => {
  const authority = localStorage.getItem("authorities");
  if(!authority) {
    return true;
  }

  if(authority === "undefined") {
    return true;
  }

  const authMap = JSON.parse(authority);
  if(authorityUUID in authMap) {
    if((permissionKey & authMap[authorityUUID].value2) === permissionKey) {
      return true;
    }
    return false;
  }

  // マスタに権限がない場合(=SNCの不手際等でマスタ登録ができていない場合)
  return true;
};

/**
 * 複数の権限のいずれかを持っている場合
 * @param {*} permissionKeyList
 * @param {*} authorityUUID
 * @returns
 */
export const hasAnyPermission = (permissionKeyList, authorityUUID) => {
  const authority = localStorage.getItem("authorities");
  if(!authority) {
    return true;
  }

  const authMap = JSON.parse(authority);
  if(authorityUUID in authMap) {
    for(const permissionKey of permissionKeyList) {
      if((permissionKey & authMap[authorityUUID].value) === permissionKey) {
        return true;
      }
    }
    return false;
  }
  return true;
};


export const Constant = {
  // ページ遷移時間
  PAGE_TRANSITION_SECONDS: 1000
};
